import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import NoRowItem from './NoItemRow';
import TableHeader from './TableHeader';
import TableItemRow from './TableItemRow';
import { TableWrapper } from '../styles';

const GroupProductTable = ({...props}) => {

  return (
      <TableContainer component={Paper}>
        <TableWrapper>
          <Table sx={{ minWidth: 650 }} aria-label="Product group table">
            <TableHeader isGroups={props.isGroups}/>
            <TableBody>
              {props.items && props.items.length > 0 ? props.items.map((row) => (
                  <TableItemRow 
                    isGroups={props.isGroups}
                    isProductGroupOpen={props.isProductGroupOpen}
                    closeAccording={props.closeAccording}
                    getProductsFromGroup={props.getProductsFromGroup}
                    row={row}
                    openEditGroup={props.openEditGroup}
                    deleteGroup={props.deleteGroup}
                    productsFromGroup={props.productsFromGroup}
                    deleteProduct={props.deleteProduct}
                    openEditProduct={props.openEditProduct}
                    setProductDTO={props.setProductDTO}
                    productDTO={props.productDTO}
                    editProduct={props.editProduct}
                    key={row.name + row.id}
                  />
                )) 
                :
                <NoRowItem isGroups={props.isGroups}/>
              }
            </TableBody>
          </Table>
        </TableWrapper>
      </TableContainer>
  );
};

export default GroupProductTable;
